export default "__VITE_ASSET__1ebe19ac__"